module.exports = __webpack_public_path__ + "static/Peyote-logo-dark-b913eaf5c837af3ce9c904d6e9fc0e2e.svg";